import { Button, Modal } from 'antd';
import { useState } from 'react';
import { ContainerFooter, Content, ModalContainer } from './styles';

import owlImg from '../../../../assets/img/pet/corujaProfessora.png';
import { apiNode } from '../../../../services/api';

interface LeaveLeagueModalProps {
  isOpen: boolean;
  closeModal: () => void;
  updateHasLeague: () => Promise<void>;
}

export const LeaveLeagueModal = ({
  closeModal,
  isOpen,
  updateHasLeague,
}: LeaveLeagueModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLeaveLeague = async () => {
    try {
      setIsLoading(true);
      const response = await apiNode.get('/ligas/users');
      const { id } = response.data.participante;

      await apiNode.delete(`/ligas/participantes/${id}`);

      await updateHasLeague();
      closeModal();
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };
  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="teste">
            <Button
              type="primary"
              onClick={handleLeaveLeague}
              loading={isLoading}
              disabled={isLoading}
              key="exitLeague"
            >
              Sim
            </Button>
            ,
            <Button
              type="primary"
              onClick={closeModal}
              disabled={isLoading}
              key="stayInLeague"
            >
              Não
            </Button>
            ,
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>ATENÇÃO!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>Ao abandonar sua liga seus pontos serão zerados!</p>
            <p>Tem certeza que deseja sair?</p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
